import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../firebase.init';

const MyItem = () => {
    const [user] = useAuthState(auth);
    const [myitem, setMyitem] = useState([]);
    useEffect(() => {
        const email = user?.email;
        const url = `https://protected-plateau-21838.herokuapp.com/myitem?email=${email}`;
        fetch(url)
            .then(res => res.json())
            .then(data => setMyitem(data))
    }, [user]);

    const handleDelete = (id) => {
        const url = `https://protected-plateau-21838.herokuapp.com/products/${id}`
        fetch(url, {
            method: 'DELETE'
        })
            .then(Response => Response.json())
            .then(data => {
                const remaining = myitem.filter(product => product._id !== id)
                setMyitem(remaining)
            })
    }

    return (
        <div >
            <h3>My Item: {myitem.length}</h3>
            <div className='row justify-content-center '>
                {
                    myitem.map(item => <div className='col-md-3 shadow-lg p-2 m-3'>
                        <img className='w-75' src={item.img} alt="" />
                        <li>Name:{item.name}</li>
                        <li>Price:{item.price}</li>
                        <button onClick={() => handleDelete(item._id)} className='btn btn-success px-3 bg-red-600 text-white fw-bold py-1 rounded'>Delete</button>
                    </div>)
                }
            </div>
        </div>
    );
};

export default MyItem;